'use client'

import { useQuery } from '@tanstack/react-query'
import {
  fetchLandingCarouselSlides,
  getLandingCarouselFallbackSlides,
} from './landing-carousel'
import type { CmsLandingCarouselPageKey } from './types'

/** baby: Section Play demo uses the first published carousel slide (same order as demos). */
export function useLandingCarouselFirstDemoSrc(pageKey: CmsLandingCarouselPageKey): string {
  const fallback = getLandingCarouselFallbackSlides(pageKey)[0]?.demoSrc ?? ''
  const { data } = useQuery({
    queryKey: ['landing-carousel', pageKey],
    queryFn: () => fetchLandingCarouselSlides(pageKey),
    staleTime: 60_000,
    placeholderData: () => getLandingCarouselFallbackSlides(pageKey),
  })
  return data?.[0]?.demoSrc ?? fallback
}
